import * as yup from 'yup';

import { YUP_OLD_EMAIL_REGEX } from '@clearverify/constants';

const ERROR_MESSAGE = 'Format is incorrect';

export const emailValidationSchema = yup.string().test('valid-email', ERROR_MESSAGE, value => {
  if (!value || (value && value.length === 0)) return true;
  return YUP_OLD_EMAIL_REGEX.test(String(value));
});
